import { createElement, memo, useMemo, useState, useContext } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Icon from '@max/leez-icon';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import CitySelectionModal from '../CitySelection/CitySelectionModal';
const MyComponent = (props) => {
    var _a, _b, _c, _d;
    const { cityInfo, destinationCityInfo, originCityStyle, destinationCityStyle, originCity, destinationCity, arcImage, handleOriginCityChange, handleDestinationCityChange, _communication } = props;
    const ctx = useContext(global === null || global === void 0 ? void 0 : global._EngineGlobalContext);
    const { _LXReport } = ctx;
    const [visible, setVisible] = useState(false);
    const [cityType, setCityType] = useState('');
    const handleReportOriginCityMV = city => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport('b_daodian_lowcode_7xlshxub_mv', {
            valLab: {
                city_id: city.value || '-999',
                city_name: city.title || '-999'
            }
        });
    };
    const handleReportDestionationCityMV = city => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport('b_daodian_lowcode_qqg2ihij_mv', {
            valLab: {
                city_id: city.value || '-999',
                city_name: city.title || '-999'
            }
        });
    };
    const onCityChange = (city, cityType) => {
        // console.log(222333, cityType, city)
        const handler = cityType === 'origin' ? handleOriginCityChange : handleDestinationCityChange;
        handler(city);
        // 切换后手动上报MV
        if (cityType === 'origin') {
            handleReportOriginCityMV(city);
        }
        else {
            handleReportDestionationCityMV(city);
        }
        setVisible(false);
    };
    const originStyle = useMemo(() => {
        return {
            fontSize: originCityStyle.fontSize + 'rpx',
            fontWeight: originCityStyle.fontWeight,
            textColor: originCityStyle.textColor,
            otherTextColor: originCityStyle.otherTextColor,
            iconColor: originCityStyle.iconColor
        };
    }, [originCityStyle]);
    const destinationStyle = useMemo(() => {
        return {
            fontSize: destinationCityStyle.fontSize + 'rpx',
            fontWeight: destinationCityStyle.fontWeight,
            textColor: destinationCityStyle.textColor,
            otherTextColor: destinationCityStyle.otherTextColor,
            iconColor: destinationCityStyle.iconColor
        };
    }, [destinationCityStyle]);
    const CitySelector = props => {
        const { city, type, style, prefix, suffix } = props || {};
        return <View style={{
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            // width: '560rpx',
            borderRadius: '8rpx'
        }} onClick={() => {
            setCityType(type);
            setVisible(!visible);
        }}>
        <View style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        }}>
          <Text x-if={prefix} className="city-select-item-prefix" style={{
            fontWeight: style.fontWeight,
            fontSize: style.fontSize,
            color: style.otherTextColor || '#000'
        }}>{prefix}</Text>
          <Text style={{
            minWidth: '64rpx',
            fontWeight: style.fontWeight,
            fontSize: style.fontSize,
            color: style.textColor
        }}>
            {city === null || city === void 0 ? void 0 : city.title}
          </Text>
          <Text x-if={suffix} className="city-select-item-prefix" style={{
            fontWeight: style.fontWeight,
            fontSize: style.fontSize,
            color: style.otherTextColor || '#000'
        }}>{suffix}</Text>
        </View>
        <View style={{
            width: '10rpx'
        }}/>
        <Icon name={cityType == type && visible ? 'jiantouxianshang' : 'jiantouxianxia'} type='label2' nopaddingMode={false} color={style.iconColor}></Icon>
      </View>;
    };
    return <View style={{
        position: 'relative',
        width: ((_a = arcImage.width) !== null && _a !== void 0 ? _a : 750) + 'rpx',
        height: ((_b = arcImage.height) !== null && _b !== void 0 ? _b : 192) + 'rpx'
    }}>
      <Image x-if={arcImage === null || arcImage === void 0 ? void 0 : arcImage.url} style={{
        position: 'absolute',
        width: ((_c = arcImage.width) !== null && _c !== void 0 ? _c : 750) + 'rpx',
        height: ((_d = arcImage.height) !== null && _d !== void 0 ? _d : 192) + 'rpx'
    }} source={{
        uri: arcImage === null || arcImage === void 0 ? void 0 : arcImage.url
    }}/>
      <View className='city-select-item-container' style={{
        top: originCityStyle.top + 'rpx',
        left: originCityStyle.left + 'rpx'
    }}>
        <Sensor onAppear={() => handleReportOriginCityMV(originCity)}>
          <CitySelector city={originCity} type="origin" style={originStyle} prefix="从" suffix="出发"/>
        </Sensor>
      </View>
      <View className='city-select-item-container' style={{
        bottom: destinationCityStyle.bottom + 'rpx',
        right: destinationCityStyle.right + 'rpx'
    }}>
        <Text style={{
        fontSize: destinationCityStyle.fontSize + 'rpx',
        fontWeight: destinationCityStyle.fontWeight,
        color: destinationCityStyle.otherTextColor || '#000',
        marginRight: '12rpx'
    }}>高铁 {props.runTimeEnd}h 可达城市推荐:</Text>
        <Sensor onAppear={() => handleReportDestionationCityMV(destinationCity)}>
        <CitySelector city={destinationCity} type="destination" style={destinationStyle}/>
      </Sensor>
      </View>
      <CitySelectionModal cityData={cityType === 'origin' ? cityInfo : destinationCityInfo.nameList.length ? destinationCityInfo : cityInfo} visible={visible} city={cityType === 'origin' ? originCity === null || originCity === void 0 ? void 0 : originCity.title : destinationCity === null || destinationCity === void 0 ? void 0 : destinationCity.title} cityType={cityType} onCityChange={onCityChange} onClose={() => setVisible(false)} _communication={_communication}/>
    </View>;
};
export default memo(MyComponent);
